import React from "react";
import { deleteRide, setEnableRide } from "../actions/rides";
import { tempAlWait } from "../helpers";
import { faEllipsisVertical, faEye, faEyeSlash, faPen, faPlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { setEnableParc } from "../actions/parc";
import { connect } from "react-redux";

class AdminItemRide extends React.Component {
    state = {
        optActive: false,
        ride: null,
        tempEnable: false
    }

    componentDidMount() {
        this.setState({
            ride: this.props.data
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redDelRide != this.props.redDelRide) {
            this.props.changeAlert(this.props.redDelRide.alert);

            if (this.props.redDelRide.isNext) {
                this.props.refreshList(true);
            }
        }
        if (this.props.redRideEnable != prevProps.redRideEnable && this.state.tempEnable) {
            this.props.changeAlert(this.props.redRideEnable.alert);

            if (this.props.redRideEnable.isNext) {
                let tempRide = this.state.ride;
                tempRide.isActive = !tempRide.isActive;
                this.setState({
                    ride: tempRide,
                    tempEnable: false
                })
            } else {
                this.setState({
                    tempEnable: false
                })
            }
        }
    }

    handleDelete(id) {
        if (window.confirm("Souhaitez-vous réellement supprimer cette attraction ?")) {
            this.props.changeAlert(tempAlWait());
            this.props.deleteRide({id: id});
        }
    }

    handleEnable(el) {
        el.preventDefault();
        
        this.props.setEnableRide({
            rideId: this.state.ride?.id,
            isActive: !this.state.ride?.isActive,
        });
        this.props.changeAlert(tempAlWait());
        this.setState({
            tempEnable: true
        })
    }
    
    render() {
        return <li className={`admin__item admin__item--ride ${this.state.ride?.isNew && "admin__item--new"}`}>
            {/** Id **/}
            <span className="admin__item__id">{this.state.ride?.id}</span>

            {/** Parc **/}
            <span className="admin__item__text">{this.state.ride?.parc.name}</span>

            {/** Description **/}
            <span className="admin__item__text">{
                this.state.ride?.nameFr == null ?
                    this.state.ride?.nameOr :
                    this.state.ride?.nameFr    
            }</span>

            {/** Est actif **/}
            {
                this.state.ride?.isNew ?
                    <span
                        className="admin__item__text"
                        title="L'attraction n'est pas activée dans les temps d'attente"
                        aria-label="L'attraction n'est pas activée dans les temps d'attente"
                    >
                        <FontAwesomeIcon icon={faEyeSlash} />
                    </span> :
                    <button
                        className="admin__item__eyebtn"
                        onClick={(el) => this.handleEnable(el)}
                        title={this.state.ride?.isActive ? "L'attraction est activée dans les temps d'attente" : "L'attraction n'est pas activée dans les temps d'attente"}
                        aria-label={this.state.ride?.isActive ? "L'attraction est activée dans les temps d'attente" : "L'attraction n'est pas activée dans les temps d'attente"}
                    >
                        {this.state.ride?.isActive ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                    </button>
            }

            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Modifier **/}
                {
                    this.state.ride?.isNew ?
                    <Link
                        title="Ajouter l'attraction"
                        aria-label="Ajouter l'attraction"
                        className="admin__item__optbtn"
                        to={`/admin/attraction/ajout/${this.state.ride?.rideId}`}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </Link> : 
                    <Link
                        title="Modifier l'attraction"
                        aria-label="Modifier l'attraction"
                        className="admin__item__optbtn"
                        to={`/admin/attraction/edit/${this.state.ride?.id}`}
                    >
                        <FontAwesomeIcon icon={faPen} />
                    </Link>
                }

                {/** Supprimer **/}
                {
                    this.state.ride?.isNew == false &&
                    <button
                        title="Supprimer l'attraction"
                        aria-label="Supprimer l'attraction"
                        className="admin__item__optbtn admin__item__optbtn--del"
                        onClick={() => this.handleDelete(this.state.ride?.id)}
                    >
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                }
            </div>

            {/** Options bouton **/}
            <button
                title={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                aria-label={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                className="admin__item__btnopt"
                onClick={() => this.setState({optActive: !this.state.optActive})}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
        </li>
    }
}

const mapStateToProps = state => {
    return {
        redDelRide: state.redDelRide,
        redRideEnable: state.redRideEnable
    }
}

const mapDispatchToProps = {
    deleteRide,
    setEnableRide
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminItemRide);